import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from '@mui/material'
import { find, map, noop } from 'lodash'
import PropTypes from 'prop-types'

function TyresTable({
  axle,
  head,
  initialValues,
  tyresWear,
  tyresType,
  updateValues,
}) {
  const [values, setValues] = useState({})
  const { t } = useTranslation()

  useEffect(() => {
    const tyresSet = find(initialValues, ['type', tyresType])
    setValues(tyresSet?.[axle] || {})
  }, [axle, initialValues, tyresType])

  const handleChange = (e) => {
    e.preventDefault()
    const { name, value } = e.target

    setValues((prevState) => ({ ...prevState, [name]: value }))
    updateValues(axle, tyresType, { ...values, [name]: value })
  }

  return (
    <div>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{head}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                name="make"
                label="Marka"
                variant="outlined"
                fullWidth
                onChange={handleChange}
                value={values.make || ''}
                InputLabelProps={{ shrink: true }}
                sx={{ mb: 2 }}
              />
              <TextField
                name="model"
                label="Model"
                variant="outlined"
                fullWidth
                onChange={handleChange}
                value={values.model || ''}
                InputLabelProps={{ shrink: true }}
                sx={{ mb: 2 }}
              />
              <TextField
                name="size"
                label="Rozmiar"
                variant="outlined"
                fullWidth
                onChange={handleChange}
                value={values.size || ''}
                InputLabelProps={{ shrink: true }}
                sx={{ mb: 2 }}
              />
              <TextField
                name="age"
                label="Rok produkcji"
                variant="outlined"
                fullWidth
                onChange={handleChange}
                value={values.age || ''}
                InputLabelProps={{ shrink: true }}
                sx={{ mb: 2 }}
              />
              <FormControl variant="outlined" fullWidth>
                <InputLabel shrink>{t('controlsEditTires')}</InputLabel>
                <Select
                  name="conditionId"
                  input={<OutlinedInput notched label="Stan opon" />}
                  value={values.conditionId || ''}
                  onChange={handleChange}
                >
                  {map(tyresWear, ({ value, name }, key) => (
                    <MenuItem key={key} value={value}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  )
}

TyresTable.propTypes = {
  axle: PropTypes.oneOf(['front', 'rear']),
  head: PropTypes.string,
  initialValues: PropTypes.array,
  tyresWear: PropTypes.array,
  tyresType: PropTypes.string,
  updateValues: PropTypes.func,
}
TyresTable.defaultProps = {
  axle: 'front',
  head: '',
  initialValues: [],
  tyresWear: [],
  tyresType: '',
  updateValues: noop,
}
export default TyresTable
